
import { combineReducers } from "redux";
import { configureStore } from '@reduxjs/toolkit';
import createWebStorage from 'redux-persist/lib/storage/createWebStorage';
import { persistStore, persistReducer } from "redux-persist";
import userReducer from "./Reducers/userReducers";
import generalReducer from "./Reducers/generalReducers";
import messageReducer from "./Reducers/MessageReducers";
import loaderReducer from "./Reducers/LoaderReducers";
import teachrReducer from "./Reducers/TeachrReducers";
import studentReducer from "./Reducers/StudentReducers";
import simulatorReducer from "./Reducers/SimulatorReducers";
import simulateurReducer from "./Reducers/SimulateurReducers";
import procurationSapReducers from "./Reducers/ProcurationSapReducers";
import StepperSapReducers from "./Reducers/StepperSapReducers";
import StepperAeReducers from "./Reducers/StepperAeReducers";
import procurationAeReducers from "./Reducers/ProcurationAeReducers";
import punctualCourseReducers from "./Reducers/PunctualCourseReducers";
import sponsorshipReducers from "./Reducers/SponsorshipReducers";
import { declarationCourseReducers, endDeclareCourseReducers } from "./Reducers/DeclarationCourseReducers";
import { aiciOnboardingReducers } from "./Reducers/AiciOnboardingReducers";
import { declarationV2Reducers } from "./Reducers/DeclarationV2Reducers";

const createNoopStorage = () =>{
    return {
        getItem(_key: any) {
            return Promise.resolve(null);
        },
        setItem(_key: any, value: any) {
            return Promise.resolve(value);
        },
        removeItem(_key: any){
            return Promise.resolve();
        },
    };
};
const storage = typeof window !== 'undefined' ? createWebStorage("local") : createNoopStorage();
const rootPersistConfig = {
    key: "root_redux_persist",
    storage: storage,
    whitelist: [
        "user", 
        "general", 
        "teachr", 
        "student", 
        "punctualCourse",
        "declarationCourse",
        "simulator", 
        "simulateur", 
        "procurationSap",
        "stepperSap", 
        "stepperAe",
        "procurationAe",
        "sponsorship",
        "endDeclareCourse",
        "aiciOnboarding",
        "declarationV2"
    ],
};

const generalPersistConfig = {
    key: "general_redux_persist",
    storage: storage,
    whitelist: ["authorizations", "alreadyLaunched"],
};

const rootReducer = combineReducers({
    user: userReducer,
    general: persistReducer(generalPersistConfig, generalReducer),
    message: messageReducer,
    loader: loaderReducer,
    teachr: teachrReducer,
    student: studentReducer,
    punctualCourse: punctualCourseReducers,
    declarationCourse: declarationCourseReducers,
    simulator: simulatorReducer,
    procurationSap: procurationSapReducers,
    procurationAe: procurationAeReducers,
    simulateur: simulateurReducer,
    stepperSap: StepperSapReducers,
    stepperAe: StepperAeReducers,
    sponsorship : sponsorshipReducers,
    endDeclareCourse: endDeclareCourseReducers,
    aiciOnboarding: aiciOnboardingReducers,
    // déclaration de cours v2 (parcours /declarer), indépendante de declarationCourse
    declarationV2: declarationV2Reducers,
});

const persistedReducer = persistReducer(rootPersistConfig, rootReducer,);

// export const store = createStore(persistedReducer);
// export const store = configureStore({
//     reducer: persistedReducer, 
//     middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: {
//         ignoredActions: ['SET_TEACHR_INFO','persist/PERSIST', 'persist/REHYDRATE','GET_CHILD_NO_ACTIVE',],
//         ignoredPaths: ['payload.teachr'],
//       },
//     }),
//     // Activer Redux DevTools seulement en mode développement
//     devTools: process.env.NODE_ENV !== 'production',  
//   });
export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [
            'SET_TEACHR_INFO',
            'persist/PERSIST',
            'persist/REHYDRATE',
            'GET_CHILD_NO_ACTIVE','meta.arg', 'payload.timestamp'
          ],
          ignoredPaths: ['payload.teachr','teachr.teach'],
        },
        immutableCheck: false,
      }),
      // .concat(createImmutableStateInvariantMiddleware()), // Ajout du middleware d'immuabilité
    devTools: process.env.NODE_ENV !== 'production', // Activer Redux DevTools seulement en développement
  });

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const persistor = persistStore(store);
export type AppState = ReturnType<typeof rootReducer>;
